import { gql } from "@apollo/client";

export const GET_PENDING_GRADUATION_REQUESTS_QUERY = gql`
  query GetPendingGraduationRequests($legacyId: String) {
    universities(legacyId: $legacyId) {
      legacyId
      name
      graduationRequests(status: "pending") {
        id
        graduationDate
        status
        submittedBy {
          id
          name
        }
        processedBy {
          id
          name
        }
        processedAt
        rejectionReason
        person {
          id
          firstName
          lastName
          middleName
          pgaId
          email
          informalName
          gender
          profilePhoto
          displayName
          latestProgram {
            id
            status
            programType {
              id
              name
            }
          }
          contactAddressId
          contactAddress {
            id
            address1
            address2
            city
            state
            postalCode
          }
          phoneNumbers {
            id
            phoneNumber
            phoneType
            phoneFormatted
          }
          addresses {
            id
            address1
            address2
            city
            state
            postalCode
          }
          primarySectionAffiliation {
            id
            primary
          }
          primarySection {
            id
            name
          }
          sectionAffiliations {
            id
            primary
            section {
              id
              name
            }
          }
          bands {
            id
            startedOn
            programType {
              id
              name
            }
          }
          mainProgramType {
            id
            name
          }
          totalInternshipMonths
          playingAbilityTestStatus {
            status
            completed
            expired
            activeSuspension {
              startDate
              endDate
            }
          }
          cohortStatus
          universityCohort {
            id
            name
          }
          educationLatestPgmProgram {
            curriculumVersion
            startDate
            endDate
            level
            levelCode
            careerPath
            programType
            completed
            pgmProgramCompleted
            pgmProgramExpirationDate
            levelExpirationDate
            eligibleForGraduation
          }
          educationPgmProgramHistory {
            curriculumVersion
            startDate
            endDate
            level
            levelCode
            careerPath
            programType
            completed
            pgmProgramCompleted
            pgmProgramExpirationDate
            levelExpirationDate
            programRequirements {
              requireId
              notes
              remarks
              score
              levelCode
              completionStatus
              completionDate
              isCompleted
              isInProgress
              createDate
              requirementDefinition {
                levelCode
                courseDescription
                courseId
                description
                requireId
                requireType
              }
            }
          }
        }
      }
    }
  }
`;
